import React from 'react';
import { CodeEditor } from '../questions';

function CodeRefactoringQuestion({ question, value = '', onChange, disabled = false }) {
  return (
    <CodeEditor
      question={question}
      value={value}
      onChange={onChange}
      disabled={disabled}
      label="Your refactored code:"
    />
  );
}

export default CodeRefactoringQuestion;
